import { render } from "./PlaceCreationView.vue?vue&type=template&id=57239b46"
import script from "./PlaceCreationView.vue?vue&type=script&lang=js"
export * from "./PlaceCreationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Location/PlaceCreationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57239b46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57239b46', __exports__)) {
    api.reload('57239b46', __exports__)
  }
  
  module.hot.accept("./PlaceCreationView.vue?vue&type=template&id=57239b46", () => {
    api.rerender('57239b46', render)
  })

}


export default __exports__